import { render } from "./SmallToggleButton.vue?vue&type=template&id=46930943"
import script from "./SmallToggleButton.vue?vue&type=script&lang=js"
export * from "./SmallToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__